import React from 'react';
import { motion } from 'framer-motion';
export function AboutEvening() {
  return <section className="py-24 px-4 relative" data-id="element-8">
      <div className="max-w-3xl mx-auto text-center" data-id="element-9">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-10">
          <h2 className="text-4xl md:text-5xl font-serif text-velvet mb-8" data-id="element-11">
            About the <br className="md:hidden" data-id="element-12" />
            <span className="text-carrot italic" data-id="element-13">Talk</span>
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-velvet/90 font-light leading-relaxed" data-id="element-14">
            <p data-id="element-15">
              AI is changing how the web is built — from the first wireframe to
              the production deploy. In just ten minutes we'll fly through what
              has actually shifted in the day-to-day of designers, developers,
              and the teams who ship software.
            </p>
            <p data-id="element-16">
              Three lightning segments, a live demo, and a clear takeaway —
              served fast, before your coffee gets cold. Whether you're hands-on
              with code or simply curious how your team's workflow is evolving,
              you'll leave with a sharper picture of where things are heading.
            </p>
            <p className="text-carrot italic font-normal pt-2" data-id="element-17">
              Because in business, as in magic, the real trick is knowing where
              to look.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}